import React, { FC } from 'react';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { Asset } from '../../../../interfaces';
import { Button } from '../../../components';
import { useNavigate } from 'react-router-dom';
import { priceDigit } from 'scripts';
import { Spin } from 'antd';

interface Props {
    item: Asset;
}

const MyWalletBalanceCard: FC<Props> = ({ item }) => {
    const navigate = useNavigate();
    return (
        <div className="bg-white border border-primary-20 rounded-lg flex-1 flex flex-col p-4 w-full h-full box-border">
            <div className="flex items-center gap-3 p-4 mb-4 border-b border-primary-20">
                <CoinIcon className="w-8 h-8 text-darkPurple-100" symbol={item.symbol} />
                <label className="font-bold text-sm">{item.name}</label>
                <span className="font-medium text-xs en">{item.symbol?.toUpperCase()}</span>
                <span className="flex-1" />
            </div>
            {item.symbol?.toUpperCase() !== 'IRT' && (
                <h4 className="text-darkPurple-100 mg-1 text-base font-bold mb-1 flex-1">
                    آخرین قیمت: {priceDigit(item.lastPrice)} تومان
                </h4>
            )}
            {item.symbol?.toUpperCase() === 'IRT' && (
                <h6 style={{ direction: 'rtl' }} className="!text-right text-darkPurple-60 text-sm font-medium mb-3 en">
                    موجودی: {priceDigit(item.balance)} {item.symbol?.toUpperCase()}
                </h6>
            )}
            <div className="flex items-center justify-end gap-2">
                {item.symbol?.toUpperCase() === 'IRT' && (
                    <>
                        <Button
                            className={'!h-8 text-sm'}
                            disabled={!item?.isDepositEnable}
                            onClick={() => navigate('/wallet/deposit')}
                        >
                            واریز
                        </Button>
                        <Button
                            className={'!h-8 text-sm'}
                            disabled={!item?.isWidthrawEnable}
                            onClick={() => navigate('/wallet/withdrawal')}
                        >
                            برداشت
                        </Button>
                    </>
                )}
                <Button
                    className={'!h-8 text-sm'}
                    disabled={!item?.isTradeEnable}
                    onClick={() =>
                        navigate(
                            item.symbol?.toUpperCase() !== 'IRT'
                                ? `/trade?symbol=${item.symbol?.toUpperCase()}`
                                : '/trade',
                        )
                    }
                >
                    معامله
                </Button>
            </div>
        </div>
    );
};

export default MyWalletBalanceCard;
